import { useEffect, useState } from 'react';

const NOT_TEXT = ['checkbox', 'radio', 'range', 'button', 'submit', 'file', 'color'];

function isTextField(el) {
  if (!el) return false;
  if (el.isContentEditable || el.tagName === 'TEXTAREA') return true;
  return el.tagName === 'INPUT' && !NOT_TEXT.includes(el.type);
}

// Клавиатура «открыта», когда фокус в текстовом поле. Сравнивать высоту
// видимой области с окном нельзя: в Safari на iPhone window.innerHeight
// уменьшается вместе с клавиатурой, разница выходит нулевой, и режим не
// включался вовсе (тест владельца 27.09: правка протокола под клавиатурой).
// Хук работает только на телефоне, а там фокус в поле = экранная клавиатура.

const CLOSED = { open: false, height: null, top: 0 };

/**
 * Состояние экранной клавиатуры телефона по visualViewport.
 *
 * Высота каркаса — по visualViewport: 100dvh клавиатуру не учитывает, и без
 * подгонки низ экрана с полем ввода оказывается под ней. Высота приходит
 * событием resize, когда клавиатура доехала.
 */
export function useKeyboard(enabled) {
  const [state, setState] = useState(CLOSED);
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!enabled || !vv) { setState(CLOSED); return undefined; }
    let timer = null;
    const update = () => {
      const open = isTextField(document.activeElement);
      const next = open
        ? { open: true, height: Math.round(vv.height), top: Math.round(vv.offsetTop) }
        : CLOSED;
      setState((prev) => (prev.open === next.open && prev.height === next.height && prev.top === next.top
        ? prev : next));
    };
    // focusout приходит раньше, чем фокус встанет на следующее поле, — ждём.
    const later = () => { clearTimeout(timer); timer = setTimeout(update, 60); };
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    document.addEventListener('focusin', later);
    document.addEventListener('focusout', later);
    update();
    return () => {
      clearTimeout(timer);
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      document.removeEventListener('focusin', later);
      document.removeEventListener('focusout', later);
    };
  }, [enabled]);
  return state;
}
